var sw = {};

if (!window.slidersVerticalInitialized) {
    let wheelTimeout = 0;

    document
        .querySelectorAll('.slider-vertical-section .swiper')
        .forEach((slider) => {

            let speed = parseInt(slider.getAttribute('data-speed')) * 1000;
            if (isTouchDevice()) {
                speed = parseInt(slider.getAttribute('data-mobile-speed')) * 1000;
            }

            sw = new Swiper(slider, {
                calculateHeight: true,
                direction: 'vertical',
                slidesPerView: 'auto',
                freeMode: true,
                spaceBetween: 0,
                loop: true,
                allowTouchMove: isTouchDevice(),
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false,
                },
                mousewheel: {
                    sensitivity: 0.5,
                    releaseOnEdges: true,
                },
                loopedSlides: 2,
                speed: speed,
                on: {
                    scroll: function (swiper, event) {
                        swiper.autoplay.stop();
                        clearTimeout(wheelTimeout);

                        wheelTimeout = setTimeout(function () {
                            swiper.autoplay.start();
                        }, 500);
                    },
                    activeIndexChange: function (swiper) {
                        let index = swiper.realIndex + 1;

                        document
                            .querySelectorAll(
                                '.slider-vertical-section-graphics img'
                            )
                            .forEach((img) => {
                                img.classList.remove('current');
                            });
                        let graphic = document
                        .querySelector(
                            '.slider-vertical-section-graphics img:nth-child(' +
                                index +
                                ')'
                        ); 
                        if (graphic) {
                            graphic.classList.add('current');
                        }
                        
                    },
                },
            });
        });

    window.slidersVerticalInitialized = true;
}
